import { initializeApp } from 'firebase/app';
import { getAuth, connectAuthEmulator } from 'firebase/auth';
import { getFirestore, connectFirestoreEmulator } from 'firebase/firestore';
import { getFunctions, connectFunctionsEmulator } from 'firebase/functions';
import { getDatabase, connectDatabaseEmulator } from 'firebase/database';
console.log('Current NODE_ENV:', process.env.NODE_ENV);
console.log('REACT_APP_USE_EMULATOR:', process.env.REACT_APP_USE_EMULATOR);

const firebaseConfig = {
    apiKey: "AIzaSyAyRoyGWd_K6zGWiy5TPr_HoK2GScAsgS4",
    authDomain: "meld-auth-1102c.firebaseapp.com",
    projectId: "meld-auth-1102c",
    storageBucket: "meld-auth-1102c.appspot.com",
    messagingSenderId: "656894341087",
    appId: "1:656894341087:web:ac2e043ab4c0e4d642de6a",
    measurementId: "G-NLDSPPW3N9"
};

const app = initializeApp(firebaseConfig);
const functions = getFunctions(app, 'us-central1'); // Explicitly specify region
const auth = getAuth(app);
const db = getFirestore(app);
const database = getDatabase(app);


if (process.env.REACT_APP_USE_EMULATOR === 'true') {
    console.log('Connecting to emulators...');
    connectAuthEmulator(auth, 'http://localhost:9099');
    connectFirestoreEmulator(db, 'localhost', 8080);
    connectFunctionsEmulator(functions, 'localhost', 5001);
    connectDatabaseEmulator(database, 'localhost', 9000);
}

export { app, auth, db, functions, database };